module.exports = ".cell {\r\n    word-wrap: anywhere;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/for-signing/list/forsigning.list.component.css
// module id = ./src/app/components/dashboard/for-signing/list/forsigning.list.component.css
// module chunks = main